export const CORPS_COLORS = {
  "Gros Œuvre / Structure": "#D97706",
  "Charpente / Couverture": "#B45309",
  "Menuiserie Extérieure": "#2563EB",
  "Plâtrerie / Isolation": "#0D9488",
  "Électricité / CFC": "#7C3AED",
  "Plomberie / CVC": "#0284C7",
  "Revêtements / Peinture": "#E11D48",
  "Aménagements Extérieurs": "#16A34A",
};

export const CORPS_LIST = Object.keys(CORPS_COLORS);

export const colorFor = (name) => CORPS_COLORS[name] || "#64748B";

export const addDays = (isoDate, days) => {
  const d = new Date(isoDate + "T00:00:00");
  d.setDate(d.getDate() + days);
  return d;
};

export const fmtDate = (d) =>
  d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });

export const fmtShort = (d) =>
  d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" });

// Jours écoulés depuis la date de démarrage (peut être négatif si projet futur)
export const daysSinceStart = (startDate) => {
  const start = new Date(startDate + "T00:00:00");
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return Math.floor((now - start) / (1000 * 60 * 60 * 24));
};

// Statut d'une tâche vs date du jour: "late" | "in_progress" | "upcoming"
export const taskStatus = (task, startDate) => {
  const today = daysSinceStart(startDate);
  const end = task.start_day + task.duration_days;
  if (today >= end) return "late";
  if (today >= task.start_day) return "in_progress";
  return "upcoming";
};
